import schema from "./firebaseSchema";
import { setDBSchema, getRef } from "./firebaseUtil";

const refs = schema;

setDBSchema(refs);

export { refs, getRef };
